<!-- Vehicle Price Sheet Modal -->
<div class="modal fade" id="kt_modal_vh_price_sheet" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h2 class="fw-bold mb-0">VEHICLE COST SUMMARY</h2>
        <div class="d-flex align-items-center">
          <!-- Save Button -->
          <button type="button" class="btn btn-primary me-3" (click)="onSubmit()" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"
              aria-hidden="true"></span>
            Save
          </button>
          <!-- Close Button -->
          <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
            <i class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
        <form [formGroup]="priceSheetForm" (ngSubmit)="onSubmit()">

          <!-- Vehicle Information Header -->
          <div class="card mb-5" *ngIf="selectedVehicle">
            <div class="card-body p-4">
              <div class="row align-items-center">
                <div class="col-md-2">
                  <div class="symbol symbol-60px me-3">
                    <div class="symbol-label rounded"
                      [style.background-image]="selectedVehicle.pictures && selectedVehicle.pictures.length > 0 ? 'url(' + selectedVehicle.pictures[0] + ')' : ''"
                      [class.bg-light-primary]="!selectedVehicle.pictures || selectedVehicle.pictures.length === 0"
                      style="background-size: cover; background-position: center;">
                      <i class="ki-duotone ki-car fs-2 text-primary"
                        *ngIf="!selectedVehicle.pictures || selectedVehicle.pictures.length === 0">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                    </div>
                  </div>
                </div>
                <div class="col-md-10">
                  <h4 class="fw-bold text-dark mb-1">{{ getVehicleDisplayName() }}</h4>
                  <div class="text-muted">{{ selectedVehicle.inventory_no || selectedVehicle.car_no }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Price Sheet Form -->
          <div class="card">
            <div class="card-body">

              <!-- Basic Information Section -->
              <div class="row mb-5">
                <div class="col-md-3">
                  <label class="form-label">REF NUMBER</label>
                  <input type="text" class="form-control form-control-sm" formControlName="ref_number" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">Chassis Number</label>
                  <input type="text" class="form-control form-control-sm" formControlName="chassis_number" />
                </div>
                <div class="col-md-2">
                  <label class="form-label">Auction Date</label>
                  <input type="date" class="form-control form-control-sm" formControlName="auction_date" />
                </div>
                <div class="col-md-2">
                  <label class="form-label">Auction Lot Number</label>
                  <input type="text" class="form-control form-control-sm" formControlName="auction_lot_number" />
                </div>
                <div class="col-md-2">
                  <label class="form-label">Auction</label>
                  <input type="text" class="form-control form-control-sm" formControlName="auction" />
                </div>
              </div>

              <!-- Description Section -->
              <div class="description-section">
                <h5>Description</h5>
                <div class="row align-items-center mb-2">
                  <!-- <div class="col-md-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text">Selling Price</span>
                      <input type="number" class="form-control" formControlName="estimated_selling_price"
                        placeholder="0" />
                      <span class="input-group-text">USD</span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text">Rate</span>
                      <input type="number" class="form-control" formControlName="estimated_rate" placeholder="0" />
                    </div>
                  </div> -->
                  <div class="col-md-2 text-center">
                    <span class="fw-bold">Selling Price(USD)</span>
                  </div>
                  <div class="col-md-2 text-center">
                    <span class="fw-bold">Rate</span>
                  </div>
                  <div class="col-md-2 text-center">
                    <span class="fw-bold">Actual Cost(JPY)</span>
                  </div>
                  <div class="col-md-3 text-center">
                    <span class="fw-bold">Sales Cost</span>
                  </div>
                  <div class="col-md-3 text-center">
                    <span class="fw-bold">Difference</span>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-md-2">
                    <input type="number" class="form-control form-control-sm" formControlName="actual_selling_price_usd"
                      placeholder="0" />
                  </div>
                  <div class="col-md-2">
                    <input type="number" class="form-control form-control-sm" formControlName="actual_rate" placeholder="0" />
                  </div>
                  <div class="col-md-2">
                    <input type="number" class="form-control form-control-sm" formControlName="actual_actual_cost_jpy"
                      placeholder="0" />
                  </div>
                  <div class="col-md-3">
                    <input type="number" class="form-control form-control-sm" formControlName="actual_sales_cost"
                      placeholder="0" />
                  </div>
                  <div class="col-md-3 text-center">
                    <span class="fw-bold text-success">{{
                      calculateDifference(
                        (priceSheetForm.get('actual_selling_price_usd')?.value || 0) +
                        (priceSheetForm.get('actual_rate')?.value || 0) +
                        (priceSheetForm.get('actual_actual_cost_jpy')?.value || 0) +
                        (priceSheetForm.get('actual_sales_cost')?.value || 0),
                        (priceSheetForm.get('estimated_selling_price_usd')?.value || 0) +
                        (priceSheetForm.get('estimated_rate')?.value || 0) +
                        (priceSheetForm.get('estimated_actual_cost_jpy')?.value || 0) +
                        (priceSheetForm.get('estimated_sales_cost')?.value || 0)
                      ) }}</span>
                  </div>
                </div>
              </div>

              <!-- Price Sheet Table -->
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 40%;"></th>
                      <th style="width: 20%;" class="text-center">Actual Cost(JPY)</th>
                      <th style="width: 20%;" class="text-center">Cost(JPY)</th>
                      <th style="width: 20%;" class="text-center">Difference</th>
                    </tr>
                  </thead>
                  <tbody>

                    <!-- AUCTION CHARGES Section -->
                    <tr>
                      <td class="fw-bold bg-light">AUCTION CHARGES</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Auction Charges</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_auction_charges" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_auction_charges" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_auction_charges')?.value,
                        priceSheetForm.get('estimated_auction_charges')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Auction Price</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_auction_price" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_auction_price" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_auction_price')?.value,
                        priceSheetForm.get('estimated_auction_price')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Auc Price Tax
                        <input type="number" class="form-control form-control-sm d-inline-block ms-2"
                          style="width: 60px;" formControlName="actual_auc_price_tax_percentage" />%
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_auc_price_tax_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm bg-light"
                          formControlName="actual_auction_price_tax" readonly /></td>
                      <td><input type="number" class="form-control form-control-sm bg-light"
                          formControlName="estimated_auction_price_tax" readonly /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_auction_price_tax')?.value,
                        priceSheetForm.get('estimated_auction_price_tax')?.value) }}</td>
                    </tr>
                    <tr class="table-info">
                      <td class="fw-bold">Auction Price + Tax Total</td>
                      <td class="fw-bold text-center">{{ (priceSheetForm.get('actual_auction_price')?.value || 0) + (priceSheetForm.get('actual_auction_price_tax')?.value || 0) }}</td>
                      <td class="fw-bold text-center">{{ (priceSheetForm.get('estimated_auction_price')?.value || 0) + (priceSheetForm.get('estimated_auction_price_tax')?.value || 0) }}</td>
                      <td class="fw-bold text-center">{{ calculateDifference((priceSheetForm.get('actual_auction_price')?.value || 0) + (priceSheetForm.get('actual_auction_price_tax')?.value || 0), (priceSheetForm.get('estimated_auction_price')?.value || 0) + (priceSheetForm.get('estimated_auction_price_tax')?.value || 0)) }}</td>
                    </tr>
                    <tr>
                      <td>Bid Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_bid_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_bid_charge" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_bid_charge')?.value,
                        priceSheetForm.get('estimated_bid_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Bid Charge Tax
                        <input type="number" class="form-control form-control-sm d-inline-block ms-2"
                          style="width: 60px;" formControlName="actual_bid_charge_tax_percentage" />%
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_bid_charge_tax_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm bg-light"
                          formControlName="actual_bid_price_tax" readonly /></td>
                      <td><input type="number" class="form-control form-control-sm bg-light"
                          formControlName="estimated_bid_price_tax" readonly /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_bid_price_tax')?.value,
                        priceSheetForm.get('estimated_bid_price_tax')?.value) }}</td>
                    </tr>
                    <tr class="table-info">
                      <td class="fw-bold">Bid Charge + Tax Total</td>
                      <td class="fw-bold text-center">{{ (priceSheetForm.get('actual_bid_charge')?.value || 0) + (priceSheetForm.get('actual_bid_price_tax')?.value || 0) }}</td>
                      <td class="fw-bold text-center">{{ (priceSheetForm.get('estimated_bid_charge')?.value || 0) + (priceSheetForm.get('estimated_bid_price_tax')?.value || 0) }}</td>
                      <td class="fw-bold text-center">{{ calculateDifference((priceSheetForm.get('actual_bid_charge')?.value || 0) + (priceSheetForm.get('actual_bid_price_tax')?.value || 0), (priceSheetForm.get('estimated_bid_charge')?.value || 0) + (priceSheetForm.get('estimated_bid_price_tax')?.value || 0)) }}</td>
                    </tr>
                    <tr>
                      <td>Sold Charge Seiyaku</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_sold_charge_seiyaku" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_sold_charge_seiyaku" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_sold_charge_seiyaku')?.value,
                        priceSheetForm.get('estimated_sold_charge_seiyaku')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Selling Charge shuppin</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_selling_charge_shuppin" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_selling_charge_shuppin" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_selling_charge_shuppin')?.value,
                        priceSheetForm.get('estimated_selling_charge_shuppin')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Re-Auc Sold Price</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_re_auc_sold_price" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_re_auc_sold_price" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_re_auc_sold_price')?.value,
                        priceSheetForm.get('estimated_re_auc_sold_price')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Recycling</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_recycling" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_recycling" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_recycling')?.value,
                        priceSheetForm.get('estimated_recycling')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ auctionChargesSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ auctionChargesSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ auctionChargesSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- REFUNDS Section -->
                    <tr>
                      <td class="fw-bold bg-light">Refunds</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        Recycle Fee PAID
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_recycle_fee_paid_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_recycle_fee_paid" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_recycle_fee_paid" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_recycle_fee_paid')?.value,
                        priceSheetForm.get('estimated_recycle_fee_paid')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Automobile Tax
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_automobile_tax_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_automobile_tax" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_automobile_tax" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_automobile_tax')?.value,
                        priceSheetForm.get('estimated_automobile_tax')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Consumption tax
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_consumption_tax_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                        <input type="number" class="form-control form-control-sm d-inline-block ms-2"
                          style="width: 60px;" formControlName="actual_consumption_tax_percentage" />%
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_consumption_tax" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_consumption_tax" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_consumption_tax')?.value,
                        priceSheetForm.get('estimated_consumption_tax')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Car Insurance
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_car_insurance_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_car_insurance" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_car_insurance" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_car_insurance')?.value,
                        priceSheetForm.get('estimated_car_insurance')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Weight Tax
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_weight_tax_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_weight_tax" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_weight_tax" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_weight_tax')?.value,
                        priceSheetForm.get('estimated_weight_tax')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Radiation Check Fee
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_radiation_check_fee_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_radiation_check_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_radiation_check_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_radiation_check_fee')?.value,
                        priceSheetForm.get('estimated_radiation_check_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>
                        Meijhenko Deposit
                        <div class="form-check form-check-sm d-inline-block ms-2">
                          <input class="form-check-input" type="checkbox"
                            formControlName="actual_meijhenko_deposit_refundable" />
                          <label class="form-check-label">Refundable</label>
                        </div>
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_meijhenko_deposit" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_meijhenko_deposit" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_meijhenko_deposit')?.value,
                        priceSheetForm.get('estimated_meijhenko_deposit')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ refundsSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ refundsSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ refundsSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- LOCAL TRANSPORT RIKUSO Section -->
                    <tr>
                      <td class="fw-bold bg-light">LOCAL TRANSPORT RIKUSO</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>1st Transport Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_first_transport_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_first_transport_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_first_transport_charge')?.value,
                        priceSheetForm.get('estimated_first_transport_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>2nd Transport Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_second_transport_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_second_transport_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_second_transport_charge')?.value,
                        priceSheetForm.get('estimated_second_transport_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>3rd Transport Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_third_transport_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_third_transport_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_third_transport_charge')?.value,
                        priceSheetForm.get('estimated_third_transport_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Auction Penalty</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_auction_penalty" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_auction_penalty" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_auction_penalty')?.value,
                        priceSheetForm.get('estimated_auction_penalty')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Additional Fee "Rikuso Co."</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_additional_fee_rikuso_co" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_additional_fee_rikuso_co" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_additional_fee_rikuso_co')?.value,
                        priceSheetForm.get('estimated_additional_fee_rikuso_co')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Fuel Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_fuel_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_fuel_charge" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_fuel_charge')?.value,
                        priceSheetForm.get('estimated_fuel_charge')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ localTransportSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ localTransportSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ localTransportSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- YARD COST Section -->
                    <tr>
                      <td class="fw-bold bg-light">YARD COST</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Engine Number</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_engine_number" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_engine_number" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_engine_number')?.value,
                        priceSheetForm.get('estimated_engine_number')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Custom / Shipping Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_custom_shipping_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_custom_shipping_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_custom_shipping_charge')?.value,
                        priceSheetForm.get('estimated_custom_shipping_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Yard-Cut Penalty</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_yard_cut_penalty" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_yard_cut_penalty" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_yard_cut_penalty')?.value,
                        priceSheetForm.get('estimated_yard_cut_penalty')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Photo Shooting Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_photo_shooting_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_photo_shooting_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_photo_shooting_fee')?.value,
                        priceSheetForm.get('estimated_photo_shooting_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Yard to Port YOKOHAMA</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_yard_to_port_yokohama" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_yard_to_port_yokohama" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_yard_to_port_yokohama')?.value,
                        priceSheetForm.get('estimated_yard_to_port_yokohama')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Cutting CKD Fees</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_cutting_ckd_fees" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_cutting_ckd_fees" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_cutting_ckd_fees')?.value,
                        priceSheetForm.get('estimated_cutting_ckd_fees')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Vehicle Repair</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_vehicle_repair" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_vehicle_repair" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_vehicle_repair')?.value,
                        priceSheetForm.get('estimated_vehicle_repair')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Cleaning Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_cleaning_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_cleaning_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_cleaning_fee')?.value,
                        priceSheetForm.get('estimated_cleaning_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Inner Cargo Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_inner_cargo_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_inner_cargo_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_inner_cargo_charge')?.value,
                        priceSheetForm.get('estimated_inner_cargo_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>YARD STORAGE FEE</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_yard_storage_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_yard_storage_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_yard_storage_fee')?.value,
                        priceSheetForm.get('estimated_yard_storage_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Vanning</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_vanning" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_vanning" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_vanning')?.value,
                        priceSheetForm.get('estimated_vanning')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Parts Disposal Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_parts_disposal_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_parts_disposal_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_parts_disposal_fee')?.value,
                        priceSheetForm.get('estimated_parts_disposal_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Gas Removal Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_gas_removal_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_gas_removal_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_gas_removal_charge')?.value,
                        priceSheetForm.get('estimated_gas_removal_charge')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Additional Inspection Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_additional_inspection_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_additional_inspection_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_additional_inspection_fee')?.value,
                        priceSheetForm.get('estimated_additional_inspection_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Mileage repair</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_mileage_repair" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_mileage_repair" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_mileage_repair')?.value,
                        priceSheetForm.get('estimated_mileage_repair')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Parts</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_parts" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_parts" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_parts')?.value,
                        priceSheetForm.get('estimated_parts')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ yardCostSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ yardCostSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ yardCostSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- PRE-EXPORT INSPECTION COSTS Section -->
                    <tr>
                      <td class="fw-bold bg-light">PRE-EXPORT INSPECTION COSTS</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Pre-Export Inspection</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_pre_export_inspection" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_pre_export_inspection" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_pre_export_inspection')?.value,
                        priceSheetForm.get('estimated_pre_export_inspection')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>JEVIC</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_jevic" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_jevic" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_jevic')?.value,
                        priceSheetForm.get('estimated_jevic')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>EAA</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_eaa" /></td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_eaa" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_eaa')?.value,
                        priceSheetForm.get('estimated_eaa')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>ATI PSI</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_ati_psi" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_ati_psi" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_ati_psi')?.value,
                        priceSheetForm.get('estimated_ati_psi')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>MB INSP CANCEL FEE</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_mb_insp_cancel_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_mb_insp_cancel_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_mb_insp_cancel_fee')?.value,
                        priceSheetForm.get('estimated_mb_insp_cancel_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>OSIJ</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_osij" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_osij" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_osij')?.value,
                        priceSheetForm.get('estimated_osij')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>CAT FEE</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_cat_fee" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_cat_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_cat_fee')?.value,
                        priceSheetForm.get('estimated_cat_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Heat Treatment (FUJ)</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_heat_treatment_fuj" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_heat_treatment_fuj" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_heat_treatment_fuj')?.value,
                        priceSheetForm.get('estimated_heat_treatment_fuj')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>JAM</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_jam" /></td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_jam" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_jam')?.value,
                        priceSheetForm.get('estimated_jam')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ preExportInspectionSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ preExportInspectionSubtotal.estimated | number:'1.0-0' }}
                      </td>
                      <td class="fw-bold text-center">{{ preExportInspectionSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- SHIPPING COSTS Section -->
                    <tr>
                      <td class="fw-bold bg-light">SHIPPING COSTS</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>BL Charges</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_bl_charges" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_bl_charges" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_bl_charges')?.value,
                        priceSheetForm.get('estimated_bl_charges')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Shipping Extra Costs</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_shipping_extra_costs" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_shipping_extra_costs" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_shipping_extra_costs')?.value,
                        priceSheetForm.get('estimated_shipping_extra_costs')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Ocean Freight</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_ocean_freight" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_ocean_freight" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_ocean_freight')?.value,
                        priceSheetForm.get('estimated_ocean_freight')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Cargo - CTN</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_cargo_ctn" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_cargo_ctn" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_cargo_ctn')?.value,
                        priceSheetForm.get('estimated_cargo_ctn')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>THC</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_thc" /></td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_thc" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_thc')?.value,
                        priceSheetForm.get('estimated_thc')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Seal Fee</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_seal_fee" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_seal_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_seal_fee')?.value,
                        priceSheetForm.get('estimated_seal_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Doc Fee</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_doc_fee" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_doc_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_doc_fee')?.value,
                        priceSheetForm.get('estimated_doc_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Booking and Commission</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_booking_and_commission" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_booking_and_commission" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_booking_and_commission')?.value,
                        priceSheetForm.get('estimated_booking_and_commission')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>SURRENDER FEE</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_surrender_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_surrender_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_surrender_fee')?.value,
                        priceSheetForm.get('estimated_surrender_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>BL DOCS FEE</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_bl_docs_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_bl_docs_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_bl_docs_fee')?.value,
                        priceSheetForm.get('estimated_bl_docs_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Freight Rate</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_freight_rate" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_freight_rate" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_freight_rate')?.value,
                        priceSheetForm.get('estimated_freight_rate')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ shippingCostsSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ shippingCostsSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ shippingCostsSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- AIRMAIL CHARGES Section -->
                    <tr>
                      <td class="fw-bold bg-light">AIRMAIL CHARGES</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>DHL Docs Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_dhl_docs_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_dhl_docs_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_dhl_docs_fee')?.value,
                        priceSheetForm.get('estimated_dhl_docs_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>FEDEX</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_fedex" />
                      </td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_fedex" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_fedex')?.value,
                        priceSheetForm.get('estimated_fedex')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>EMS</td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="actual_ems" /></td>
                      <td><input type="number" class="form-control form-control-sm" formControlName="estimated_ems" />
                      </td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_ems')?.value,
                        priceSheetForm.get('estimated_ems')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ airmailChargesSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ airmailChargesSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ airmailChargesSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- ISL INTERNAL Section -->
                    <tr>
                      <td class="fw-bold bg-light">ISL INTERNAL</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Sales Commission</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_sales_commission" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_sales_commission" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_sales_commission')?.value,
                        priceSheetForm.get('estimated_sales_commission')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Marine Insurance</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_marine_insurance" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_marine_insurance" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_marine_insurance')?.value,
                        priceSheetForm.get('estimated_marine_insurance')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ islInternalSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ islInternalSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ islInternalSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- Bank Charges Section -->
                    <tr>
                      <td class="fw-bold bg-light">Bank Charges</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>LC Amendment Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_lc_amendment_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_lc_amendment_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_lc_amendment_fee')?.value,
                        priceSheetForm.get('estimated_lc_amendment_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Collection Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_collection_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_collection_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_collection_fee')?.value,
                        priceSheetForm.get('estimated_collection_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Stamp Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_stamp_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_stamp_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_stamp_fee')?.value,
                        priceSheetForm.get('estimated_stamp_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Yen Exchange</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_yen_exchange" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_yen_exchange" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_yen_exchange')?.value,
                        priceSheetForm.get('estimated_yen_exchange')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Issuing Bank Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_issuing_bank_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_issuing_bank_fee" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_issuing_bank_fee')?.value,
                        priceSheetForm.get('estimated_issuing_bank_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>Transfer Fee</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_transfer_fee" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_transfer_fee" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_transfer_fee')?.value,
                        priceSheetForm.get('estimated_transfer_fee')?.value) }}</td>
                    </tr>
                    <tr>
                      <td>LC Cable Charge</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_lc_cable_charge" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_lc_cable_charge" /></td>
                      <td class="text-center">{{
                        calculateDifference(priceSheetForm.get('actual_lc_cable_charge')?.value,
                        priceSheetForm.get('estimated_lc_cable_charge')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ bankChargesSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ bankChargesSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ bankChargesSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- EXTRA CHARGES Section -->
                    <tr>
                      <td class="fw-bold bg-light">EXTRA CHARGES</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>EXTRA PARTS</td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="actual_extra_parts" /></td>
                      <td><input type="number" class="form-control form-control-sm"
                          formControlName="estimated_extra_parts" /></td>
                      <td class="text-center">{{ calculateDifference(priceSheetForm.get('actual_extra_parts')?.value,
                        priceSheetForm.get('estimated_extra_parts')?.value) }}</td>
                    </tr>
                    <tr class="table-secondary">
                      <td class="fw-bold">Sub Total</td>
                      <td class="fw-bold text-center">¥ {{ extraChargesSubtotal.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ extraChargesSubtotal.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">{{ extraChargesSubtotal.difference | number:'1.0-0' }}</td>
                    </tr>

                    <!-- TOTALS Section -->
                    <tr class="table-dark">
                      <td class="fw-bold">Total Cost</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.totalCost.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.totalCost.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.totalCost.difference | number:'1.0-0' }}</td>
                    </tr>
                    <tr class="table-success">
                      <td class="fw-bold">Income</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.income.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.income.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.income.difference | number:'1.0-0' }}</td>
                    </tr>
                    <tr class="table-warning">
                      <td class="fw-bold">Refunds</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.refunds.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.refunds.estimated | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.refunds.difference | number:'1.0-0' }}</td>
                    </tr>
                    <tr class="table-danger">
                      <td class="fw-bold">Loss</td>
                      <td class="fw-bold text-center text-danger">¥ {{ grandTotals.loss.actual | number:'1.0-0' }}</td>
                      <td class="fw-bold text-center text-danger">¥ {{ grandTotals.loss.estimated | number:'1.0-0' }}
                      </td>
                      <td class="fw-bold text-center">¥ {{ grandTotals.loss.difference | number:'1.0-0' }}</td>
                    </tr>

                  </tbody>
                </table>
              </div>

            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
